var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84089 5.84169L4.8929 12.2681C4.89664 12.7858 4.47987 13.2086 3.96213 13.2123C3.44433 13.216 3.02163 12.7993 3.01791 12.2815L2.96598 5.8511L2.96594 5.84437C2.96591 5.09313 3.25849 4.38683 3.78968 3.85563C4.32087 3.32444 5.02717 3.03186 5.77842 3.0319L12.2733 3.01758C12.7911 3.01652 13.2116 3.43545 13.2127 3.95322C13.2132 4.21275 13.1082 4.44791 12.9381 4.61798C12.7689 4.78726 12.5353 4.89207 12.277 4.89256L5.78024 4.90691C5.528 4.90691 5.29257 5.00439 5.1155 5.18146C4.93907 5.35789 4.84159 5.59227 4.84089 5.84169ZM14.1223 15.4476L6.1361 7.4614C5.77077 7.09608 5.77143 6.50316 6.13755 6.13703C6.50368 5.7709 7.0966 5.77025 7.46192 6.13557L15.4481 14.1217C15.8134 14.4871 15.8128 15.08 15.4466 15.4461C15.0805 15.8122 14.4876 15.8129 14.1223 15.4476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.21db1b26534d4636ea15831135a61f27.svg";
export { ForwardRef as ReactComponent };